import React from 'react'
import SectionHeader from '../components/SectionHeader'
// import FilmCard from '../components/cards/FilmCard'
// import jokerPoster from '../assets/img/jokerPoster.webp'
// import FilmsSlider from '../components/main/FilmsSlider'
// import Header from '../components/main/Header'
// import MainButton from '../components/btns/MainButton'
import PurpleBtn from '../components/btns/PurpleBtn'
import CompaniesComponent from '../components/main/CompaniesComponent'
import CenterFilms from '../components/main/CenterFilms'
import { useNavigate } from 'react-router-dom'
import EventsSlider from '../components/main/EventsSlider'
const MainPage = () => {
  const navigate = useNavigate();

  const clickToFilms = () => {
    navigate('/films')
  }

  const clickCoupon = () => {
    window.location.href = 'https://loyl.me/3703';
  };

  return (
    <>
    {/* <Header/> */}
    <div className='pt-[50px]'></div>
    <SectionHeader title='Bu Gün'/>
    <CenterFilms/>
    {/* <FilmsSlider/> */}
    <div className='aa'>
      <PurpleBtn onClick={clickToFilms} title='Hamısına bax'/>
    </div>

    <SectionHeader title='Tədbirlər'/>
    <EventsSlider/>

    <SectionHeader title='Kampaniyalar'/>
    <CompaniesComponent/>
    <div>
      <PurpleBtn onClick={clickCoupon} title='Kompaniyalara qoşul'/>
    </div>

    
    </>
  )
}

export default MainPage